import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import MenuItem from 'material-ui/MenuItem';
import DropDownMenu from 'material-ui/DropDownMenu';
import debounce from 'lodash/debounce';
import { Header } from './header.js';
import { Footer } from './footer.js';
import './landing.css';
import * as util from './util.js';
import './search.css';

let faqSearch = [
  {
    content: "Wir bieten <u>kostenfreie</u> Auftragssuchen an. Klicken Sie <a class='fontColorBlue' target='_blank' href='/contact/#contactform'>hier</a>.",
    title: "Nicht fündig geworden?",
    key: 0
  }
];

export function ListItem(props) {
  return (
    <div>
      {props.children}
    </div>
  );
}

const typeToLabel = {
  'non-comm': 'Angebote aus dem Gesundheitswesen oder Personen',
  'comm': 'Angebote von Firmen',
  'software': 'Software',
  'service': 'Dienstleistung',
  'document': 'Dokumente',
  'used-software': 'Gebraucht-Software',
  'research-software': 'Software Forschung & Lehre',
  'tender': 'Ausschreibung',
  'other': 'Hardware und Sonstige',
  'regulation': '' /* christos: I did not find anything relevant to regulation */
}

export class Search extends Component {

  constructor(props) {
    super(props);

    this.state = {
      filter: "",
      numberOfStars: 0,
      query: "",
      lastSentQuery: '',
      searchInProgress: false,
      results: []
    }
    // debounce by some ms to avoid sending each keystroke as a separate backend request
    this.debouncedHandleQueryChange = debounce(this.debouncedHandleQueryChange, 600);
    this.handleQueryChange = this.handleQueryChange.bind(this);
  }

  componentWillMount() {
    let storedQuery = localStorage.getItem('ayacandas_search') || '';
    let storedFilter = localStorage.getItem('ayacandas_filter') || '';
    this.setState({
      query: storedQuery,
      filter: storedFilter,
    }, () => this.doSearch());
  }

  handleFilterChange = (event, index, filter) => {
    // return, if the current filter was selected again
    if(filter === this.state.filter)
      return;
    this.setState({filter, searchInProgress: true}, () => {
      this.doSearch(() => localStorage.setItem('ayacandas_filter', filter));
    });
  }

  handleQueryChange(event) {
    this.setState({
      query: event.target.value
    });
    this.debouncedHandleQueryChange(event.target.value);
  }

  debouncedHandleQueryChange(query) {
    const oldQuery = this.state.lastSentQuery.trim();
    if(oldQuery !== query.trim()) {
      this.setState({query, searchInProgress: true}, () => {
        this.doSearch(() => localStorage.setItem('ayacandas_search', query));
      });
    } else {
      // no search, just update the search input field
      this.setState({query});
    }
  }

  doSearch(callback) {
    const { filter, query, numberOfStars } = this.state;

    let url = `/api/search?q=${query}`;
    if (filter !== null && filter !== '') {
      url += `&filter=${filter}`;
    }
    if (numberOfStars >= 0) {
      url += `&numberOfStars=${numberOfStars}`;
    }
    fetch(url, {
      headers: util.defaultHeaders()
    })
      .then( resp => {
        this.setState({searchInProgress: false});
        return resp.json();
      })
      .then( json => {
        if(json && json.results)
          this.setState({
            results: json.results,
            lastSentQuery: query,
          }, callback);
      })
      .catch( err => {
        this.setState({searchInProgress: false});
      });
  }

  render() {
    const self = this;
    var detailLink = function (type, id) {
      switch (type) {
        case "document":
          return `/document-details/${id}`;
        case "researchsoftware":
          return `/researchsoftware-details/${id}`;
        case "software":
          return `/show-software/${id}`;
        case "service":
          return `/show-service/${id}`;
        case "tender":
          return `/show-tender/${id}`;
        case "used-software":
          return `/show-used-software/${id}`;
        case "other":
          return `/show-other/${id}`;
        default:
          return `/search`;
      }
    }

    let items = this.state.results.map(function (result, index) {
      var shorten = function (string) {
        if (string !== undefined && string !== null && string.length > 200) {
          return string.substring(0, 200) + '[...]';
        } else {
          return string;
        }
      }

      return (
        <ListItem key={result.type + '-' + result.id}>
          <div style={{ backgroundColor: 'white', wordWrap: 'break-word', width: '100%', padding:'3%' }} >
            <div className="Bold WordWrap SearchLabels">
              <Link to={detailLink(result.type, result.id)}>{result.name}
              </Link>
            </div>
            <div className="SearchLabels">{result.product_role === 'commercial' ? result.product_company : null}</div>
            <p className="Description">{shorten(result.description)}</p>
            <p className="Description">{shorten(result.desc)}</p>
            <p className="Description">{shorten(result.aim)}</p>
            <div className="ToEndRightV2">
              {result.id && <div className="button"> <Link to={detailLink(result.type, result.id)}>Zum Angebot</Link> </div>}
            </div>

            {result.categories_text !== undefined ?
            <div style={{ color: '#1F6A81', fontFamily: 'open sans' }}>
              <div className="SearchLabels blackColor">Kategorie</div>
              {result.categories_text.map((obj, i) => <div key={ 'cat'+i } style={{ marginBottom: '1%' }}><SimilarProducts category={obj} categoryID={result.categories_as_array[i]} productUUID={result.uuid} /></div>)}

            </div> :
            <ul><span></span></ul>}
          </div>
          {index + 1 < self.state.results.length ? <div style={{ width: '100%' }} ><hr className="hr" /></div> : null}
        </ListItem>
      )
    });

    const styles = {
      menu: {
        display: 'block',
        fontFamily: 'open sans',
        flex: 1,
        backgroundColor: '#fcfdfe',
        fontSize: 'large',
        padding: '0px 0px 0px 0px',
      },
      item: {
        fontFamily: 'open sans',
        fontSize: 'large',
      },
      icon: {
        display: 'inline-block',
        height: '48px',
        width: '12px',
        right: '0px',
        color: 'rgba(0, 0, 0, 0.87)',
        fill: 'rgb(0, 0, 0)',
        transition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
      }
    };

    return (
      <div className="Landing" id="contentId" >
        <Header username={this.props.username} propagateLogin={this.props.propagateLogin} />
        <div className="ContentWithBackground">
          <div className="content" id="content">
             <div className="searchMobilLabel">
              <div className="SearchFilter">
                <div className="searchInputLabelSmall">
                  Kategorie:
                </div>
                <DropDownMenu value={this.state.filter}
                              onChange={this.handleFilterChange}
                              style={styles.menu}
                              iconStyle={styles.icon}>
                  <MenuItem value='' primaryText='Alle Angebotskategorien' style={styles.item} />
                  <MenuItem value='non-comm' primaryText={typeToLabel['non-comm']} style={styles.item} />
                  <MenuItem value='comm' primaryText={typeToLabel['comm']} style={styles.item} />
                  <MenuItem value='service' primaryText={typeToLabel['service']} style={styles.item} />
                  <MenuItem value='software' primaryText={typeToLabel['software']} style={styles.item} />
                  <MenuItem value='used-software' primaryText={typeToLabel['used-software']} style={styles.item} />
                  <MenuItem value='document' primaryText={typeToLabel['document']} style={styles.item} />
                  <MenuItem value='research-software' primaryText={typeToLabel['research-software']} style={styles.item} />
                  <MenuItem value='other' primaryText={typeToLabel['other']} style={styles.item} />
                  <MenuItem value='tender' primaryText={typeToLabel['tender']} style={styles.item} />
                </DropDownMenu>
              </div>
              </div>

            <div className="searchMobilLabel">
            <div className="searchInputLabel">
              Suchbegriffe:
            </div>
              <div style={{ display: 'flex', flexGrow: 1 }} >
                <input className="SearchInput hoverYellow1" type="search" placeholder="z.B. nach Entlassmanagement oder DSGVO suchen" value={this.state.query} onChange={this.handleQueryChange} autoFocus />
              </div>
            </div>
            <div className="blabla">
              <div className="searchResult" id="searchResult">
                {/* Search in progress */}
                {this.state.searchInProgress && <h4 className="searchingText">Die Suche läuft...</h4>}
                {/* Search has Results */}
                {items}
              </div>
            </div>
            {/*<InfoBar faq={faqSearch} />*/}
          </div>
        </div>
        <Footer faqs={faqSearch}/>
      </div>
    );
  }
}

export class SimilarProducts extends Component {
  constructor(props) {
    super(props);
    this.getNeighbours = this.getNeighbours.bind(this);
    this.state = {
      neighbours: null,
      expanded: false
    };
  }

  getNeighbours() {
    if (this.state.expanded === false) {
      this.setState({ expanded: true });
      var url = `/api/similar-products?categoryid=${this.props.categoryID}&uuid=${this.props.productUUID}`;
      var self = this;
      var headers = util.defaultHeaders();
      var promise = fetch(url, {
        method: 'GET',
        headers: headers
      }).then(response => response.json())
        .catch(function (exception) {
          alert('Konnte aehnliche Produkte nicht laden.');
          console.error('Could not load similar products.', exception);
        });
      promise.then(function (json) {
        self.setState({ neighbours: json });
      });
    } else {
      this.setState({ expanded: false });
    }
  }

  render() {
    return (
      <div className="SimilarProducts">
        <span style={this.state.expanded === true ? { fontWeight: 'bold', cursor: 'pointer' } : { cursor: 'pointer' }}
              onClick={() => this.getNeighbours()} title="Aufklappen um ähnliche Produkte zu sehen">{this.props.category}</span>
        {this.state.expanded === true ?
         <div className="SearchNeighbours">
           <ul>
             {this.state.neighbours !== undefined &&
              this.state.neighbours !== null &&
              this.state.neighbours.map((obj) => <li><Link to={obj.product_link}>{obj.product_name}</Link></li>)}
           </ul>
         </div>
         : null
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/search.js